import React from 'react';

/**
 * McaEmpty — Empty state message with icon, heading, description, and optional action.
 * Used when no data is available (e.g., "No collections yet").
 * 
 * Props:
 *   - icon (node): SVG element or custom icon
 *   - title (string): Heading (h3)
 *   - description (string): Description text
 *   - action (node): Optional CTA button or link
 *   - minHeight (bool): If true, adds min-height to fill vertical space
 */
export function McaEmpty({ icon, title, description, action, minHeight = false }) {
  return (
    <div
      className="mca-empty"
      style={minHeight ? { minHeight: '400px' } : undefined}
    >
      {icon && (
        <div className="mca-empty__icon">
          {icon}
        </div>
      )}
      {title && (
        <h3>{title}</h3>
      )}
      {description && (
        <p>{description}</p>
      )}
      {action && (
        <div className="mca-empty__action">
          {action}
        </div>
      )}
    </div>
  );
}

export default McaEmpty;
